export type FeatureToken =
  | 'expressions'
  | 'landmarks'
  | 'descriptors'
  | 'ageAndGender';

export const ExpressionsFeatureToken: FeatureToken = 'expressions';
export const LandmarksFeatureToken: FeatureToken = 'landmarks';
export const DescriptorsFeatureToken: FeatureToken = 'descriptors';
export const AgeAndGenderToken: FeatureToken = 'ageAndGender';
